import React from 'react';

export default function PolitiqueConfidentialite() {
  return (
    <div className="min-h-screen bg-white py-12 px-4 sm:px-6 lg:px-8">
      <div className="max-w-3xl mx-auto">
        <h1 className="text-3xl font-bold text-gray-900 mb-8">Politique de Confidentialite</h1>
        <p className="text-sm text-gray-500 mb-8">Derniere mise a jour : 26 mars 2026</p>

        <div className="space-y-6 text-gray-700 leading-relaxed">
          <section>
            <h2 className="text-xl font-semibold text-gray-900 mb-3">1. Responsable du traitement</h2>
            <p>Bureau Agricole, edite par ETA Sauvayre, est responsable du traitement des donnees personnelles collectees via cette application.</p>
            <p>Contact : eta.sauvayre@gmail.com</p>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-gray-900 mb-3">2. Donnees collectees</h2>
            <p>Nous collectons les donnees suivantes :</p>
            <ul className="list-disc pl-6 mt-2 space-y-1">
              <li>Nom, prenom, adresse e-mail (creation de compte)</li>
              <li>Donnees d exploitation agricole (parcelles, interventions, materiel)</li>
              <li>Donnees de communication (messages WhatsApp Business, emails)</li>
              <li>Donnees de navigation (cookies techniques)</li>
            </ul>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-gray-900 mb-3">3. Finalites du traitement</h2>
            <ul className="list-disc pl-6 space-y-1">
              <li>Gestion de votre exploitation agricole (ERP)</li>
              <li>Communication avec vos collaborateurs via WhatsApp et email</li>
              <li>Assistance par intelligence artificielle</li>
              <li>Publication sur les reseaux sociaux (Facebook, Instagram)</li>
              <li>Prospection commerciale (formulaire Caloria)</li>
            </ul>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-gray-900 mb-3">4. Base legale</h2>
            <p>Le traitement est fonde sur votre consentement (article 6.1.a du RGPD) et l execution du contrat de service (article 6.1.b).</p>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-gray-900 mb-3">5. Destinataires des donnees</h2>
            <p>Vos donnees peuvent etre partagees avec :</p>
            <ul className="list-disc pl-6 mt-2 space-y-1">
              <li>Meta Platforms (WhatsApp Business API, Facebook, Instagram)</li>
              <li>Google (Drive, Calendar, Gmail - avec votre autorisation)</li>
              <li>OpenAI (assistant IA - donnees anonymisees)</li>
              <li>MongoDB Atlas (hebergement base de donnees)</li>
            </ul>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-gray-900 mb-3">6. Duree de conservation</h2>
            <p>Vos donnees sont conservees pendant la duree de votre utilisation du service, puis supprimees dans un delai de 12 mois apres la cloture de votre compte.</p>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-gray-900 mb-3">7. Vos droits</h2>
            <p>Conformement au RGPD, vous disposez des droits suivants :</p>
            <ul className="list-disc pl-6 mt-2 space-y-1">
              <li>Droit d acces a vos donnees</li>
              <li>Droit de rectification</li>
              <li>Droit a l effacement</li>
              <li>Droit a la portabilite</li>
              <li>Droit d opposition</li>
            </ul>
            <p className="mt-2">Pour exercer vos droits, contactez-nous a : eta.sauvayre@gmail.com</p>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-gray-900 mb-3">8. Suppression des donnees</h2>
            <p>Vous pouvez demander la suppression de vos donnees a tout moment en envoyant un email a eta.sauvayre@gmail.com. La suppression sera effectuee dans un delai de 30 jours.</p>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-gray-900 mb-3">9. Cookies</h2>
            <p>L application utilise uniquement des cookies techniques necessaires a son fonctionnement. Aucun cookie publicitaire n est utilise.</p>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-gray-900 mb-3">10. Contact</h2>
            <p>Pour toute question relative a cette politique, contactez :</p>
            <p className="mt-2">ETA Sauvayre<br/>Email : eta.sauvayre@gmail.com</p>
          </section>
        </div>
      </div>
    </div>
  );
}
